import { LucideIcon } from "lucide-react";

const COLORS = {
  green: "var(--taxiway)",
  amber: "var(--amber)",
  red: "var(--alert)",
  blue: "var(--blue)",
};

export function StatCard({
  icon: Icon,
  label,
  value,
  caption,
  color = "blue",
}: {
  icon: LucideIcon;
  label: string;
  value: string | number;
  caption?: string;
  color?: keyof typeof COLORS;
}) {
  const c = COLORS[color];
  return (
    <div className="dash-in overflow-hidden rounded-sm border border-[var(--line)] bg-white">
      <div className="h-[3px]" style={{ background: c }} />
      <div className="px-4 py-3.5">
        <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-sm" style={{ background: c + "14", color: c }}>
          <Icon size={16} />
        </div>
        <div className="text-[12.5px] text-[var(--muted)]">{label}</div>
        <div className="font-display text-[26px] font-semibold leading-tight">{value}</div>
        {caption && <div className="mt-0.5 text-[11px] text-[var(--muted-2)]">{caption}</div>}
      </div>
    </div>
  );
}
